import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { SELECTED_CELL_BOX_SHADOW } from '../../constants.tsx';
import { TAG_LIST_WRAPPER_CLASS_NAME } from './constants.tsx';

type TagListWrapperProps = { isEditable?: boolean; isFocused?: boolean };

const conditionalStyle = (styleAttr: string) => {
	return fg('jira_list_checkbox_convert_to_pressable') ? styleAttr : 'unset';
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TagListWrapper = styled.div<TagListWrapperProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	className: TAG_LIST_WRAPPER_CLASS_NAME,
	display: 'flex',
	alignItems: 'center',
	width: '100%,',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	boxShadow: (props) => (props.isFocused ? SELECTED_CELL_BOX_SHADOW : 'none'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props) =>
		props.isFocused ? token('elevation.surface', 'white') : 'transparent',
	outline: 'none',
	flexWrap: 'nowrap',

	overflow: 'hidden',
	padding: `0 ${token('space.075', '6px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	cursor: ({ isEditable = true }) => (isEditable ? 'pointer' : 'default'),
	whiteSpace: 'nowrap',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div': {
		overflow: 'hidden',
		display: 'inline-flex',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	lineHeight: `${conditionalStyle('1.5')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	font: `${conditionalStyle(token('font.body', '14px'))}`,
});
